export default __webpack_public_path__ + "static/media/serviceImage2.ae110d18.jpg";